<template>
  <div>
    <div class="fee-template-detail">
      <div class="top-box">
        <div class="row-box">
          <tooltip class="name1" :txt-info="detailData.name"></tooltip>
          <div class="name2">{{ detailData.code }}</div>
          <i class="iconfont icon-bianji1 edit-icon" @click="$refs.editForm.open({ ...detailData, mechanId, type, mechanName })"></i>
          <div class="name2">
            {{ type == 1 ? '应用团队' : '应用业务员' }}：<span>{{ detailData.userNum }}</span>
          </div>
          <i class="iconfont icon-bianji1 edit-icon" @click="$refs.templateUserList.open({ ...detailData, mechanId, type })"></i>
        </div>
        <div class="row-box fee-init-box">
          <div class="name2">
            产品费率比：
            <span>首年：{{ detailData.rateVal || 0 }}%</span>
            <span>第二年：{{ detailData.rate2Val || 0 }}%</span>
            <span>第三年：{{ detailData.rate3Val || 0 }}%</span>
            <span>第四年：{{ detailData.rate4Val || 0 }}%</span>
            <span>第五年：{{ detailData.rate5Val || 0 }}%</span>
          </div>
          <i
            class="iconfont icon-bianji1 edit-icon"
            @click="
              $refs.batchSetting.open(
                {
                  templateId,
                  scale: detailData.scale,
                  rate: detailData.rateVal,
                  rate2: detailData.rate2Val,
                  rate3: detailData.rate3Val,
                  rate4: detailData.rate4Val,
                  rate5: detailData.rate5Val,
                  type
                },
                'init'
              )
            "
          ></i>
        </div>

        <el-button class="fixed-back-btn" @click="back">返回</el-button>
      </div>
      <div class="content">
        <el-form :inline="true" class="select-form-new auto">
          <el-form-item label="产品名称">
            <el-input v-model="searchParams.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="保险公司">
            <el-select clearable filterable v-model="searchParams.companyCode" placeholder="请选择">
              <el-option v-for="(bean, i) in companyList" :key="i" :label="bean.name" :value="bean.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品销售属性">
            <el-select clearable v-model="searchParams.sellType" placeholder="请选择">
              <el-option v-for="(bean, i) in sellTypeMap" :key="i" :label="bean" :value="i"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="险种分类">
            <el-select clearable v-model="searchParams.themeId" placeholder="请选择">
              <el-option v-for="(bean, i) in typeList" :key="i" :label="bean.name" :value="bean.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上架状态">
            <el-radio-group v-model="searchParams.productStatus" @change="searchAjax()">
              <el-radio label="">全部</el-radio>
              <el-radio label="2">已上架</el-radio>
              <el-radio label="1">已下架</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="btn-box">
            <el-button class="org-btn small" @click="searchAjax()">查询</el-button>
          </div>
        </el-form>
        <div class="tabs-box">
          <div class="tabs-item" :class="{ active: activeName == 'all' }" @click="tabClick('all')">全部({{ allCount }})</div>
          <div class="tabs-item" :class="{ active: activeName == '1' }" @click="tabClick('1')">有费率({{ hasCount }})</div>
          <div class="tabs-item" :class="{ active: activeName == '0' }" @click="tabClick('0')">
            无费率({{ noCount }})
            <el-tooltip effect="dark" content="无费率指的是费率为0的产品" placement="top">
              <i class="iconfont icon-wenhao1"></i>
            </el-tooltip>
          </div>
        </div>

        <el-table ref="tableRef" border :data="tableData" style="width: 100%" class="list-table" tooltip-effect="dark" v-loading="listLoading">
          <el-table-column property="productName" min-width="230" label="产品名称">
            <div slot-scope="scope">
              <span class="title">{{ scope.row.name }} </span>
              <div class="gray tag" v-if="scope.row.status == 1">已下架</div>
            </div>
          </el-table-column>
          <el-table-column property="lowPrice" label="保费" width="200">
            <div slot-scope="scope">{{ scope.row.lowPrice }}元起</div>
          </el-table-column>
          <el-table-column property="remark" label="服务费" width="350">
            <div slot-scope="scope">
              <div class="fee-box">
                <span v-if="scope.row.minCommissonVal == scope.row.maxCommissonVal">{{ scope.row.minCommissonVal || 0 }}%</span>
                <span v-else>{{ scope.row.minCommissonVal || 0 }}%~{{ scope.row.maxCommissonVal || 0 }}%</span>
                <div class="huo-fee-box" v-if="scope.row.maxSubsidyCommissionVal"><i class="huo">活</i> 最高奖励+{{ scope.row.maxSubsidyCommissionVal }}%</div>
              </div>
            </div>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  type="text"
                  size="small"
                  @click="
                    $refs.productFee.open({
                      templateId: templateId,
                      type: type,
                      productId: scope.row.id,
                      productName: scope.row.name,
                      status: scope.row.status,
                      templateName: detailData.name
                    })
                  "
                  >查看费率表</el-button
                >
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="page"
          background
          :current-page.sync="pageNum"
          :page-size.sync="pageSize"
          :layout="$tools.pageLayout"
          :total="total"
          @size-change="
            pageNum = 1;
            pageSize = $event;
            getList();
          "
          @current-change="getList()"
        ></el-pagination>
      </div>
    </div>
    <!-- 批量设置 -->
    <batchSetting ref="batchSetting" @save="batchSettingSuccess"></batchSetting>
    <!-- 新增、编辑、复制表单 -->
    <editForm ref="editForm" @reload="getDetail"></editForm>
    <!-- 模板使用团队弹窗 -->
    <templateUserList ref="templateUserList" @reload="getDetail"></templateUserList>
    <!-- 产品费率弹窗 -->
    <productFee
      ref="productFee"
      @reload="
        searchAjax();
        getDetail();
      "
    ></productFee>
  </div>
</template>
<script>
import topSearchForm from "@/components/topSearchForm";
import batchSetting from "./components/feeTemplate/batchSetting";
import editForm from "./components/feeTemplate/editForm";
import templateUserList from "./components/feeTemplate/templateUserList";
import productFee from "./components/feeTemplate/productFee";
import tooltip from "@/components/tooltip";
import { pageTool } from "@/api/mixins";
export default {
  mixins: [pageTool],
  components: {
    batchSetting,
    topSearchForm,
    templateUserList,
    productFee,
    tooltip,
    editForm,
  },
  data: () => ({
    templateId: "",
    visible: false,
    activeName: "all",
    loading: true,
    tableData: [],
    searchParams: {
      productStatus: "2",
    },
    detailData: {},//模板数据
    allCount: 0,//所有的数量
    hasCount: 0,//有费率的数量
    noCount: 0,//无费率的数量
    isAll: false,//全部产品
    companyList: [],//保司列表
    typeList: [],//分类列表
    mechanId: '',
    mechanName: '',
    type: '',
    sellTypeMap: {
      "1": "网销产品",
      "3": "经代产品",
    },
  }),
  mounted() {
    this.templateId = this.$route.query.id;
    this.mechanId = this.$route.query.mechanId;
    this.mechanName = this.$route.query.mechanName;
    this.type = this.$route.query.type;
    this.initListAjax("/master/commissonTemplate/queryCommissonProduct");
    this.getTypeList();
    this.getCompanyList();
    this.getDetail();
  },
  methods: {
    // tab点击
    tabClick(type) {
      this.activeName = type;
      this.searchAjax()
    },
    // 返回
    back() {
      history.go(-1)
    },
    // 获取模板详情
    getDetail() {
      this.$http({
        url: "/master/commissonTemplate/queryDetail",
        type: "put",
        params: { id: this.templateId }
      }).then((res) => {
        this.detailData = res.data;
      });
    },
    // 获取产品分类列表
    getTypeList() {
      this.$http({
        url: "/master/product/queryProductThemes",
        type: "put",
        params: { status: "2" }
      }).then((res) => {
        this.typeList = res.data;
      });
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: "/master/product/queryAllCompany",
        type: "put",
        params: {}
      }).then((res) => {
        this.companyList = res.data;
      });
    },
    // 批量设置成功回调
    batchSettingSuccess(type) {
      this.getDetail()
    },
    setListParams(params) {
      params.templateId = this.templateId;
      if (this.activeName == "all") {
        params.isCollocateCommisson = "";
      } else {
        params.isCollocateCommisson = this.activeName;
      }
    },
    listCallback(res) {
      this.hasCount = res.isCollocateCount;
      this.noCount = res.isNotCollocateCount;
      this.allCount = this.hasCount + this.noCount;
    }
  },
};
</script>
<style lang="scss" scoped>
@import './feeTemplateDetail.scss';
</style>

